import { gql } from '@apollo/client';
import { ORGANIZATION_PARTNER_FIELDS_FRAGMENT } from './fragments/organizations';

/* ----------------------- servicePartner ---------------------------------------  */

export const GET_ORGANIZATION_PARTNERS = gql`
    query organizationPartners(
        $PartnerId: Int
        $OrganizationId: Int
        $PartnerType: OrganizationPartnerTypeEnum
    ) {
        organizationPartners(
            data: {
                PartnerId: $PartnerId
                OrganizationId: $OrganizationId
                PartnerType: $PartnerType
            }
        ) {
            ...OrganizationPartnerFields
        }
    }
    ${ORGANIZATION_PARTNER_FIELDS_FRAGMENT}
`;

export const ADD_ORGANIZATION_PARTNER = gql`
    mutation addOrganizationPartner(
        $PartnerIds: [Int!]!
        $OrganizationId: Int!
        $PartnerType: OrganizationPartnerTypeEnum!
    ) {
        addOrganizationPartner(
            data: {
                PartnerIds: $PartnerIds
                OrganizationId: $OrganizationId
                PartnerType: $PartnerType
            }
        ) {
            ...OrganizationPartnerFields
        }
    }
    ${ORGANIZATION_PARTNER_FIELDS_FRAGMENT}
`;

export const DELETE_ORGANIZATION_PARTNER = gql`
    mutation removeOrganizationPartner($OrganizationPartnerId: Int!) {
        removeOrganizationPartner(data: { OrganizationPartnerId: $OrganizationPartnerId })
    }
`;
